import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Input } from 'antd';
import { EditorElementPopover } from '../EditorElementPopover';

export class PMap extends React.Component {
  state = {
    showBtn: false,
  };

  static propTypes = {
    googleurl: PropTypes.string, // google embed url

    className: PropTypes.string,
    // style: PropTypes.object,

    updateNode: PropTypes.func,
    address: PropTypes.array,
    publish: PropTypes.bool,
  };

  static defaultProps = {
    googleurl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1586.1327254687938!2d-121.89122792005047!3d37.336223797683665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcca32d107883%3A0x857e32831886b074!2s3-1+E+Santa+Clara+St%2C+San+Jose%2C+CA+95116!5e0!3m2!1sen!2sus!4v1561402159528!5m2!1sen!2sus',
    publish: false,
  };

  handleChange = (e) => {
    const text = e.target.value;
    this.props.updateNode(this.props.address, { text });
  };

  iconColorSelected = (color) => {
    this.props.updateNode(this.props.address, { color });
  }

  onChange = (e) => {
    const size = e.target.value;
    this.props.updateNode(this.props.address, { size });
  }

  onURLEnter = (e) => {
    const googleurl = e.target.value;
    this.props.updateNode(this.props.address, { googleurl });
  }

  popoverContent = () => (
    <React.Fragment>
      <div className="label">
        <div className="main">Google map URL</div>
        <div className="help">
          Grab the URL by selecting location on Google maps &gt; Share &gt; Embed a map.
        </div>
      </div>
      <Input
        placeholder="www.google.com/maps/embed?..."
        onPressEnter={this.onURLEnter}
      />
    </React.Fragment>
  );

  onMouseOver = (e) => {
    this.setState({ showBtn: true });
    e.stopPropagation();
  };

  onMouseOut = (e) => {
    this.setState({ showBtn: false });
    e.stopPropagation();
  };

  render() {
    const { googleurl, publish }  = this.props;

    return (
      <div
        className={cx(
          'pmap',
          this.props.className,
        )}
        onMouseOver={this.onMouseOver}
        onFocus={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onBlur={this.onMouseOut}
      >

        <div className="embed-responsive embed-responsive-4by3">
          <iframe
            className="embed-responsive-item"
            title="map"
            src={googleurl}
            frameBorder="0"
            style={{ border: 0 }} allowFullScreen
          />
        </div>

        <EditorElementPopover
          usecase="map"
          showBtn={this.state.showBtn}
          btnLabel="map"
          title="Map settings"
          content={this.popoverContent()}
          placement="bottomLeft"
          publish={publish}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/elements/PMap.jsx